import { render } from "./CookieAccept.vue?vue&type=template&id=14e47e89"
import script from "./CookieAccept.vue?vue&type=script&lang=js"
export * from "./CookieAccept.vue?vue&type=script&lang=js"

import exportComponent from "/Users/raulbajmuhametov/work/vue/grany/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__